<header class="header" [ngClass]='{"JEEcolor": color == "jee", "NEETcolor": color == "neet"}' >
    <nav class="navbar navbar-expand-lg home-navbar" >
        <a class="navbar-brand"><img src="assets/img/logo.png" alt="Logo" class="headerlogo"/></a>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto w-100 justify-content-center clearfix">
                <!-- <li class="nav-item active">
                    <a class="nav-link" (click)="clear()" href="{{homeRoute}}jee" >JEE</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="clear()" href="{{homeRoute}}neet" >
                        NEET
                    </a>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false" style="cursor: pointer">
                    FOUNDATION
                  </a>
                  <ul class="dropdown-menu dropdown webmenuleft" aria-labelledby="navbarDropdownMenuLink">
                    <li>
                      <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}jee-foundation"  style="color: #263643; cursor: pointer" >JEE Foundation</a>
                    </li>
                    <li>
                      <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}neet-foundation" style="color: #263643; cursor: pointer" >NEET Foundation</a>
                    </li>
                    <li>
                  </ul>
                </li> -->
                <!-- <li class="nav-item dropdown">
                    <ng-container *ngTemplateOutlet="cbseDropdownList;context:{ class:''}" ></ng-container>
                </li> -->
                <!-- <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" style="cursor: pointer">
                      CBSE
                    </a>
                    <ul class="dropdown-menu dropdown webmenuleft" aria-labelledby="navbarDropdownMenuLink">
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/8/full-course"  style="color: #263643; cursor: pointer" >Grade 8</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/9/full-course" style="color: #263643; cursor: pointer" >Grade 9</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/10/full-course" style="color: #263643; cursor: pointer" >Grade 10</a>
                      </li>
                      <li class="dropdown-submenu">
                        <a class="dropdown-item dropdown-toggle" style="color: #263643; cursor: pointer" >Grade 10</a>
                        <ul class="dropdown-menu">
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/10/full-course" style="color: #263643; cursor: pointer">Grade 10
                              Full Course</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/10/crash-course" style="color: #263643; cursor: pointer" >Grade 10
                              Crash Course </a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/11/full-course" style="color: #263643; cursor: pointer" >Grade 11</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/12/full-course" style="color: #263643; cursor: pointer" >Grade 12</a>
                      </li>
                    </ul>
                  </li> -->
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" style="cursor: pointer">
                      STUDY MATERIAL
                    </a>
                    <ul class="dropdown-menu dropdown webmenuleft" aria-labelledby="navbarDropdownMenuLink"> 
                      <li class="dropdown-submenu" *ngFor="let exams of surgeData">
                        <a class="dropdown-item dropdown-toggle" href="{{exams?.url}}" target="_blank" style="color: #263643; cursor: pointer" >{{exams?.exam}}</a>
                        <ul class="dropdown-menu webmenuleft">
                          <li class="dropdown-submenu" *ngFor="let ncert of exams?.data">
                            <a class="dropdown-item dropdown-toggle" href="{{ncert?.url}}" target="_blank"  style="color: #263643; cursor: pointer">{{ncert?.name}}</a>
                            <ul class="dropdown-menu dropdown webmenuleft">
                              <li *ngFor="let url of ncert?.submenu">
                                <a class="dropdown-item" href="{{url?.url}}" target="_blank" style="color: #263643; cursor: pointer">{{url?.name}}</a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false" style="cursor: pointer">
                      COURSES
                    </a>
                    <ul class="dropdown-menu dropdown webmenuleft" aria-labelledby="navbarDropdownMenuLink">
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}jee"  style="color: #263643; cursor: pointer" >JEE</a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}neet" style="color: #263643; cursor: pointer" >NEET</a>
                      </li>  
                      <li class="dropdown-submenu">
                        <a class="dropdown-item dropdown-toggle" style="color: #263643; cursor: pointer" >FOUNDATION</a>
                        <ul class="dropdown-menu webmenuleft">
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}foundation/8" style="color: #263643; cursor: pointer">Grade 8</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}foundation/9" style="color: #263643; cursor: pointer">Grade 9</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}foundation/10" style="color: #263643; cursor: pointer" >Grade 10</a>
                          </li>
                        </ul>
                      </li>
                      <li class="dropdown-submenu">
                        <a class="dropdown-item dropdown-toggle" style="color: #263643; cursor: pointer" >CBSE</a>
                        <ul class="dropdown-menu webmenuleft">
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/6/full-course"  style="color: #263643; cursor: pointer" >Grade 6</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/7/full-course"  style="color: #263643; cursor: pointer" >Grade 7</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/8/full-course"  style="color: #263643; cursor: pointer" >Grade 8</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/9/full-course"  style="color: #263643; cursor: pointer" >Grade 9</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/10/full-course"  style="color: #263643; cursor: pointer" >Grade 10</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/11/full-course"  style="color: #263643; cursor: pointer" >Grade 11</a>
                          </li>
                          <li>
                            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/12/full-course"  style="color: #263643; cursor: pointer" >Grade 12</a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="{{successHome}}">
                      SUCCESS CENTRES
                    </a>
                </li>
                  <li class="nav-item">
                    <a class="nav-link" href="{{homeRoute}}score">
                        SCORE
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" href="{{homeRoute}}doubts">
                        DOUBTS
                    </a>
                </li> -->
                <!-- <li class="nav-item">
                    <a class="nav-link" href="https://infinitylearn.com/surge/">
                        FREE MATERIAL
                    </a>
                </li> -->
                <!-- <li class="nav-item">
                    <a class="nav-link" href="pricing.html" >
                        Pricing
                    </a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link" (click)='navigateToSignIn()'>
                        Sign in
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link signup-btn" routerLink='/signup'>
                        Sign up
                    </a>
                </li>
            </ul>
        </div>
        <div id="mySidenav" class="sidenav" [ngClass]='{"open":openSidebar}'>
            <a href="javascript:void(0)" class="closebtn" (click)='openSidebar = false'>&times;</a>
            <ul>
                <!-- <li>
                    <a href="{{homeRoute}}jee" (click)="clear()">JEE</a>
                </li>
                <li><a href="{{homeRoute}}neet" (click)="clear()">NEET</a></li> -->
                <!-- <li class="nav-item dropdown">
                    <ng-container *ngTemplateOutlet="cbseDropdownList;context:{ class:'mob-dropdown'}"></ng-container>
                </li> -->
                <!-- <li class="nav-item mob-dropdown">
                  <a class="nav-link" data-toggle="collapse" data-target="#navbarfoundation" aria-expanded="false" aria-controls="collapseExample">
                    FOUNDATION <i class="fa fa-chevron-down"></i></a>
                  <ul class="dropdown collapse stupadleft" id="navbarfoundation" style="padding-left: 15px;">
                    <li class="nav-item">
                      <a class="nav-link" (click)="clear()" href="{{homeRoute}}jee-foundation">
                        JEE Foundation</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="clear()" href="{{homeRoute}}neet-foundation">
                        NEET Foundation</a>
                    </li>
                    </ul>
                  </li>  
                <li class="nav-item mob-dropdown">
                    <a class="nav-link" data-toggle="collapse" data-target="#navbarcbse" aria-expanded="false" aria-controls="collapseExample">
                      CBSE <i class="fa fa-chevron-down"></i></a>
                    <ul class="dropdown collapse stupadleft" id="navbarcbse" style="padding-left: 15px;">
                      <li class="nav-item">
                        <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/8/full-course">
                          Grade 8</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/9/full-course">
                          Grade 9</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/10/full-course">
                          Grade 10</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-toggle="collapse" data-target="#cbseGrade10" aria-expanded="false" aria-controls="collapseExample">
                          Grade 10 <i class="fa fa-chevron-down"></i></a>
                        <ul class="dropdown collapse stupadleft" id="cbseGrade10" style="padding-left: 10px;">
                          <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/10/full-course">Grade 10 Full Course</a></li>
                          <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/10/crash-course">Grade 10 Crash Course</a></li>
                        </ul>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/11/full-course" >
                          Grade 11</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/12/full-course">
                          Grade 12</a>
                      </li>
                    </ul>
                </li> -->
                <li class="nav-item mob-dropdown">
                  <a class="nav-link" data-toggle="collapse" data-target="#studymeterial" aria-expanded="false" aria-controls="collapseExample">
                  STUDY MATERIAL <i class="fa fa-chevron-down"></i></a>
                  <ul class="dropdown collapse stupadleft" id="studymeterial" style="padding-left: 15px;">
                    <li class="nav-item" *ngFor="let exams of surgeData;let a = index">
                      <a class="nav-link" data-toggle="collapse" (click)="showExams(a)" data-target="#exams{{a}}" aria-expanded="false" aria-controls="collapseExample">
                        {{exams?.exam}} <i class="fa fa-chevron-down"></i></a>
                      <ul class="dropdown collapse stupadleft" id="exams{{a}}" style="padding-left: 10px;">
                        <li class="nav-item" *ngFor="let ncert of exams?.data;let b = index"> 
                          <a class="nav-link" data-toggle="collapse" (click)="showClass(b)" data-target="#urlsn{{b}}">{{ncert?.name}} <i class="fa fa-chevron-down"></i></a>
                          <ul class="dropdown collapse stupadleft" id="urls{{b}}" style="padding-left: 10px;">
                            <li class="nav-item" *ngFor="let url of ncert?.submenu"> 
                              <a class="nav-link" href="{{url?.url}}" target="_blank">{{url?.name}}</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
              </li>
                <li class="nav-item mob-dropdown">
                  <a class="nav-link" data-toggle="collapse" data-target="#navbarcbse" aria-expanded="false" aria-controls="collapseExample">
                    COURSES <i class="fa fa-chevron-down"></i></a>
                  <ul class="dropdown collapse stupadleft" id="navbarcbse" style="padding-left: 15px;">
                    <li class="nav-item">
                      <a class="nav-link" (click)="clear()" href="{{homeRoute}}jee">JEE</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" (click)="clear()" href="{{homeRoute}}neet">NEET</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="collapse" data-target="#foundation" aria-expanded="false" aria-controls="collapseExample">
                        FOUNDATION <i class="fa fa-chevron-down"></i></a>
                        <ul class="dropdown collapse stupadleft" id="foundation" style="padding-left: 10px;">
                          <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}foundation/8">Grade 8</a></li>
                          <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}foundation/9">Grade 9</a></li>
                          <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}foundation/10">Grade 10</a></li>
                        </ul>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-toggle="collapse" data-target="#cbseGrade" aria-expanded="false" aria-controls="collapseExample">
                        CBSE <i class="fa fa-chevron-down"></i></a>
                      <ul class="dropdown collapse stupadleft" id="cbseGrade" style="padding-left: 10px;">
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/6/full-course">Grade 6</a></li>
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/7/full-course">Grade 7</a></li>  
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/8/full-course">Grade 8</a></li>
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/9/full-course">Grade 9</a></li>  
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/10/full-course">Grade 10</a></li>  
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/11/full-course">Grade 11</a></li>  
                        <li class="nav-item"> <a class="nav-link" (click)="clear()" href="{{homeRoute}}cbse/12/full-course">Grade 12</a></li>   
                      </ul>
                    </li>
                  </ul>
              </li>
              <li><a href="{{successHome}}">SUCCESS CENTRES</a></li>
                <li><a href="{{homeRoute}}score">SCORE</a></li>
                <!-- <li><a href="https://infinitylearn.com/surge/">FREE MATERIAL</a></li> -->
                <!-- <li><a href="{{homeRoute}}doubts">DOUBTS</a></li> -->
                <li><a (click)='navigateToSignIn()'>Sign in</a></li>
                <li><a routerLink='/signup' class="mobsignup-btn">Sign Up</a></li>
            </ul>
          </div>
          <span class="leftnav" (click)='openSidebar = true'>&#9776; </span>
    </nav>
</header>
<ng-template #cbseDropdownList let-lessonsCounter="class">
    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">CBSE</a>
    <ul class="dropdown-menu {{lessonsCounter}}" aria-labelledby="navbarDropdown">
        <li class="dropdown-submenu" *ngFor="let grade of cbse_grade">
            <a class="dropdown-item" (click)="clear()" href="{{homeRoute}}cbse/{{grade}}/full-course">Grade {{grade}}</a>
        </li>
    </ul>
</ng-template>